module.exports = __webpack_public_path__ + "media/images/landing/logo/logo_plans-f69f6e3c487c704d3a92eb110d4b49d9.png";